// extracted by mini-css-extract-plugin
export var checkbox = "_8c-0";
export var circle = "_8c-3";
export var horizontalContainer = "_8c-7";
export var sm = "_8c-5";
export var switch0 = "_8c-2";
export var switchDisabled = "_8c-8";
export var switchEnabled = "_8c-1";
export var textSwitchContainer = "_8c-9";
export var textSwitchOption = "_8c-a";
export var textSwitchOptionSelected = "_8c-b";
export var verticalContainer = "_8c-6";
export var xs = "_8c-4";